module.exports = __webpack_public_path__ + "img/KSAT25-45-1000-2-btn.92a31e27.png";